import { axiosInstance } from "../../../axios/axiosInstance";

const API_APPOINTMENTS_URL = "admin/orders";
const API_APPOINTMENTS_MODULE_LIST_URL = API_APPOINTMENTS_URL + "/list";
const API_APPOINTMENTS_BY_ID_URL = API_APPOINTMENTS_URL + "/view";

export const getAppointments = (dataToBeSent) => {
  return axiosInstance.get(`${API_APPOINTMENTS_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}${dataToBeSent?.role ? `&role=${dataToBeSent?.role}` : ""}&search=${dataToBeSent?.search || ""}&filters[country]=${dataToBeSent?.country || ""}&filters[order_status]=${dataToBeSent?.order_status || ""}&filters[organization_id]=${dataToBeSent?.organization_id || ""}&filters[customer_id]=${dataToBeSent?.customer_id || ""}`);
};

export const getAppointmentsById = (dataToBeSent) => {
  return axiosInstance.get(API_APPOINTMENTS_BY_ID_URL + "/" + dataToBeSent?.selectedAppointmentsId);
};
